import './i18n';
import './styling';
import '@/modules/common/initialization/serviceInitialization';

import { MsalProvider } from '@azure/msal-react';
import { AuthError } from '@azure/msal-browser';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppInsightsContext, ReactPlugin } from '@microsoft/applicationinsights-react-js';

import { App } from './App';

import { msalInstance } from '@/modules/authentication/msalInstance';
import { getConfig } from '@/modules/common/helpers/config';
import { logger } from '@common/logging/logger';

// Initialize App Insights
const reactPlugin = new ReactPlugin();
const { azure } = getConfig();
const appInsights = new ApplicationInsights({
  config: {
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    instrumentationKey: azure.insightsInstrumentationKey,
    connectionString: azure.insightsConnectionString,
  },
});
appInsights.loadAppInsights();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const startApp = async () => {
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <AppInsightsContext.Provider value={reactPlugin}>
            <App />
          </AppInsightsContext.Provider>
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
};

startApp().catch((error: unknown) => {
  logger.error('Authentication startup failed', {
    errorCode: error instanceof AuthError ? error.errorCode : 'unknown_error',
    correlationId: error instanceof AuthError ? error.correlationId : undefined,
  });
  rootElement.textContent = 'Sign-in could not be completed.';
});
